import React from "react";
import { connect } from "react-redux";
import { Formik, Form, FormikProps } from "formik";
import * as Toastr from "toastr";
import axios from "axios";
import * as yup from "yup";

import { append } from "../redux/actions/itemsAction";
import { create, print, start, stop } from "../redux/actions/quickShipsAction";
import Header from "./Header";
import Table from "./Table";
import { Shipping } from "./Shipping";
import { MICROSOFT_AZURE } from "../../utils";

declare var App: any;

class Index extends React.Component<any, any> {
  cable = null;
  state = null;

  constructor(props: any) {
    super(props);

    this.init(props);
  }

  init = (props: any) => {
    const { doors, info, schedule, printers, readers } = props;
    const [first_zone] = info.subzones;
    const initialValues = {
      printer: printers.find(
        ({ id }: any) => id == localStorage.getItem("crm_printer"),
      )?.id,
      reader: readers.find(
        ({ id }: any) => id == localStorage.getItem("crm_reader"),
      )?.id,
      door: doors.find(({ id }: any) => id == localStorage.getItem("crm_door"))
        ?.id,
      // info
      shipping_zone_id: schedule.shipping_zone_id || first_zone?.id,
      pickup_carrier: schedule.pickup_carrier,
      pickup_vehicle_plate_number: schedule.pickup_vehicle_plate_number,
      pickup_driver_name: schedule.pickup_driver_name,
      pickup_driver_phone_number: schedule.pickup_driver_phone_number,
      pickup_vehicle_trailer_number: schedule.pickup_vehicle_trailer_number,
      carrier_tracking_number: schedule.carrier_tracking_number,
      type: "serial_number",
    };

    this.state = { initialValues, loading: false };
  };

  toggleLoading = (formik: any) => {
    const { readers, schedule, start, stop, viewOnly } = this.props;
    if (viewOnly) return;

    if (this.cable) {
      this.disconnect();
      this.setState({ loading: false, door: undefined });
      stop(schedule.id, formik.values.reader);
    } else if (!formik.values.reader) {
      Toastr.error("Please select reader");
    } else {
      const reader = readers.find(({ id }: any) => id == formik.values.reader);
      if (reader.category == MICROSOFT_AZURE && !formik.values.door) {
        Toastr.error("Please select shipping zone");
        return;
      }

      this.setState({ loading: true, door: formik.values.door });
      start(schedule.id, formik.values.reader)
        .then(() => {
          const { received } = this;
          const { prefix } = this.props;
          this.cable = App.cable.subscriptions.create(
            {
              channel: "ReadsChannel",
              roomId: `${prefix.concat(formik.values.reader).join("_")}`,
            },
            { received },
          );
          this.setState({ loading: !!this.cable });
        })
        .catch(({ error }: any) => {
          this.setState({ loading: false, door: undefined });
          Toastr.error(error);
        });
    }
  };

  disconnect = () => {
    if (!this.cable) return;

    this.cable.unsubscribe();
    this.cable.consumer.disconnect();
    this.cable = null;
    this.setState({ loading: !!this.cable });
  };

  received = async ({ epcs, manual = false }: any) => {
    const { door } = this.state;
    const { acceptWrongItems, append, includeInventoryIds, prefix, readers } =
      this.props;
    const [client, store] = prefix;
    const reader = readers.find(
      ({ id }: any) => id == localStorage.getItem("crm_reader"),
    );
    const epc_ids = (
      reader.category == MICROSOFT_AZURE && door && !manual
        ? epcs.filter((t: any) => t.sub_zone_id == door)
        : epcs
    ).map((t: any) => t.EPC);

    const tagsUrl = `/${client}/api/v1/tags/tag_metadata?store_code=${store}`;
    const tags = (await axios.post(tagsUrl, epc_ids)).data.filter((tag: any) =>
      includeInventoryIds.includes(tag.status_id),
    );

    const tag_epc_ids = tags.map((tag: any) => tag.epc_id);
    const itemsUrl = `/${client}/api/v1/tags/metadata-by-epc?store_code=${store}`;
    const items = await axios.post(itemsUrl, tag_epc_ids);

    append(items.data, tags, acceptWrongItems);
  };

  handlePreview = (formik: any) => {
    if (!formik.values.printer) {
      Toastr.error("Please select printer");
      return;
    }

    const { prefix, schedule } = this.props;
    const [client, store] = prefix;
    const url = `/${client}/${store}/api/v1/crm/schedules/${schedule.id}/preview.pdf?printer_id=${formik.values.printer}&copies=1`;
    window.open(url, "_blank").focus();
  };

  handleReprint = (formik: any) => {
    if (!formik.values.printer) {
      Toastr.error("Please select printer");
      return;
    }

    const { print, schedule } = this.props;
    print(schedule.id, formik.values.printer)
      .then(() => Toastr.info("Sent to printer"))
      .catch(({ error }) => Toastr.error(error.message));
  };

  handleSubmit = (data: any) => {
    this.disconnect();
    const { create, items, prefix, schedule, stop } = this.props;
    const [client, store] = prefix;
    stop(schedule.id, data.reader);

    return create(schedule.id, items, data)
      .then(() => {
        window.location.href = `/${client}/${store}/crm/schedules/${schedule.id}/edit`;
      })
      .catch(({ error }: any) => Toastr.error(error));
  };

  handleUndo = (formik: any) => {
    const { schedule } = this.props;
    console.log("print", schedule, formik);
  };

  validationSchema = () =>
    yup.object().shape({
      pickup_carrier: yup.string().required(" ").nullable(),
      pickup_vehicle_plate_number: yup.string().required(" ").nullable(),
      pickup_driver_name: yup.string().required(" ").nullable(),
      pickup_driver_phone_number: yup.string().required(" ").nullable(),
      pickup_vehicle_trailer_number: yup.string().required(" ").nullable(),
      carrier_tracking_number: yup.string().required(" ").nullable(),
    });

  render() {
    const {
      info,
      prefix: [client, store],
      schedule,
      viewOnly,
    } = this.props;
    const { loading } = this.state;
    return (
      <Formik
        enableReinitialize
        initialValues={this.state.initialValues}
        onSubmit={this.handleSubmit}
        validationSchema={this.validationSchema}
      >
        {(formik: FormikProps<any>) => (
          <Form id="list-form">
            <Header
              formik={formik}
              loading={loading}
              onPreview={this.handlePreview}
              onReprint={this.handleReprint}
              onSubmitPrint={this.handleSubmit}
              onToggleLoading={this.toggleLoading}
              onUndo={this.handleUndo}
              schedule={schedule}
              viewOnly={viewOnly}
            />
            <Shipping info={info} schedule={schedule} viewOnly={viewOnly} />
            <Table
              client={client}
              formik={formik}
              store={store}
              received={this.received}
              viewOnly={viewOnly}
            />
          </Form>
        )}
      </Formik>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  items: state.items.data,
});

const mapDispatchToProps = {
  append,
  create,
  print,
  start,
  stop,
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
